import { useState, useEffect, useRef } from 'react';

interface Question {
  question: string;
  options: string[];
  correct: number;
}

// Bộ câu hỏi đã xáo trộn xen kẽ: mỗi cặp vị trí (2n, 2n+1) xen kẽ 4 đáp án và đúng/sai
const QUESTIONS: Question[] = [
  // 4-opt pair 1
  { question: "Khi tham gia hoạt động khám phá bản thân trên lớp, em sẽ hiểu được điều gì về mình?", options: ["Biết thêm nhiều trò chơi mới mỗi ngày", "Hiểu rõ những điểm riêng và khả năng của bản thân", "Không cần phải học bài ở trên lớp", "Có thêm nhiều thời gian để nghỉ ngơi"], correct: 1 },
  { question: "Lan rất thích vẽ tranh và thường vẽ vào giờ rảnh, điều đó được gọi là gì?", options: ["Một nhiệm vụ bắt buộc phải hoàn thành", "Một sở thích mà Lan cảm thấy vui khi làm", "Một công việc do người khác yêu cầu", "Một hoạt động không cần thiết phải làm"], correct: 1 },
  // T/F pair 1
  { question: "Hiểu rõ bản thân giúp em học tập và sinh hoạt tốt hơn mỗi ngày", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Sở thích cá nhân không quan trọng nên không cần quan tâm đến", options: ["Đúng", "Sai"], correct: 1 },
  // 4-opt pair 2
  { question: "Mỗi tối Minh đều sắp xếp sách vở gọn gàng trước khi đi ngủ, việc này thể hiện điều gì?", options: ["Một việc làm không quan trọng trong học tập", "Một thói quen tốt giúp rèn luyện bản thân mỗi ngày", "Một việc làm gây mất thời gian không cần thiết", "Một hoạt động chỉ người lớn mới cần làm"], correct: 1 },
  { question: "Khi đứng trước lớp để tự giới thiệu, em nên bắt đầu bằng cách nào?", options: ["Nói tên của một người bạn trong lớp", "Nói rõ ràng tên của mình để mọi người nhận biết", "Không nói gì và đứng im tại chỗ", "Nói những câu chuyện không liên quan"], correct: 1 },
  // T/F pair 2
  { question: "Em không cần lập thời gian biểu vì có thể làm việc tùy ý", options: ["Đúng", "Sai"], correct: 1 },
  { question: "Tự giới thiệu bản thân giúp mọi người hiểu rõ hơn về em", options: ["Đúng", "Sai"], correct: 0 },
  // 4-opt pair 3
  { question: "Khi được yêu cầu làm sản phẩm theo sở thích, em nên thực hiện như thế nào?", options: ["Làm giống hệt sản phẩm của bạn bên cạnh", "Làm theo điều mình yêu thích và cảm thấy hứng thú", "Làm cho xong mà không cần suy nghĩ", "Không tham gia hoạt động đó"], correct: 1 },
  { question: "Sau khi chơi xong, em tự giác dọn dẹp đồ chơi gọn gàng, việc này thể hiện điều gì?", options: ["Một việc làm không cần thiết trong sinh hoạt", "Một thói quen tốt giúp giữ gìn môi trường sạch sẽ", "Một việc làm khiến em cảm thấy mệt hơn", "Một nhiệm vụ chỉ người lớn cần thực hiện"], correct: 1 },
  // T/F pair 3
  { question: "Tham gia câu lạc bộ theo sở thích giúp em phát triển tốt hơn", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Không cần giữ vệ sinh cá nhân hằng ngày cũng không sao", options: ["Đúng", "Sai"], correct: 1 },
  // 4-opt pair 4
  { question: "Khi trường có nhiều câu lạc bộ, em nên chọn tham gia như thế nào cho phù hợp?", options: ["Chọn theo bạn thân mà không cần suy nghĩ", "Chọn theo sở thích và khả năng của bản thân mình", "Chọn ngẫu nhiên cho nhanh mà không cân nhắc", "Không tham gia bất cứ câu lạc bộ nào"], correct: 1 },
  { question: "Việc lập thời gian biểu mỗi ngày giúp em điều gì trong học tập và sinh hoạt?", options: ["Có thêm thời gian để chơi nhiều hơn", "Biết sắp xếp thời gian học và chơi một cách hợp lí", "Không cần phải làm bài tập về nhà", "Làm cho mọi việc trở nên khó khăn hơn"], correct: 1 },
  // T/F pair 4
  { question: "Lập kế hoạch giúp em thực hiện công việc rõ ràng và hiệu quả hơn", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Em không cần rèn luyện bản thân mỗi ngày cũng vẫn tiến bộ", options: ["Đúng", "Sai"], correct: 1 },
  // 4-opt pair 5
  { question: "Vì sao mỗi bạn cần hiểu rõ sở thích và khả năng của bản thân mình?", options: ["Để có thể khoe với bạn bè trong lớp", "Để lựa chọn hoạt động phù hợp và phát triển tốt hơn", "Để không cần tham gia học tập ở lớp", "Để có nhiều thời gian vui chơi hơn"], correct: 1 },
  { question: "Khi một bạn đang tự tin giới thiệu bản thân trước lớp, em nên làm gì?", options: ["Nói chuyện riêng với bạn bên cạnh", "Lắng nghe và thể hiện sự tôn trọng đối với bạn", "Cười chê khi bạn nói chưa hay", "Rời khỏi chỗ ngồi để làm việc khác"], correct: 1 },
  // T/F pair 5
  { question: "Làm việc theo sở thích giúp em cảm thấy vui vẻ và hứng thú hơn", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Sự tự tin giúp em thể hiện tốt hơn trước tập thể lớp", options: ["Đúng", "Sai"], correct: 0 },
  // 4-opt pair 6
  { question: "Việc tham gia biểu diễn văn nghệ trước lớp giúp em phát triển điều gì?", options: ["Làm em trở nên sợ hãi hơn trước đám đông", "Giúp em tự tin hơn khi đứng trước nhiều người", "Không giúp ích gì cho bản thân", "Chỉ làm em cảm thấy mệt mỏi"], correct: 1 },
  { question: "Khi được làm những việc đúng với sở thích của mình, em sẽ cảm thấy như thế nào?", options: ["Cảm thấy buồn chán và không muốn làm", "Cảm thấy vui vẻ và hứng thú hơn khi tham gia", "Cảm thấy mệt mỏi và không thoải mái", "Không có cảm xúc gì đặc biệt"], correct: 1 },
  // T/F pair 6
  { question: "Biết quản lí thời gian là một kĩ năng quan trọng cần rèn luyện", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Em không cần rèn luyện bản thân mỗi ngày cũng vẫn tiến bộ", options: ["Đúng", "Sai"], correct: 1 },
  // 4-opt pair 7
  { question: "Khi tự giới thiệu bản thân trước lớp, em nên nói như thế nào?", options: ["Nói nhỏ để không ai nghe rõ", "Nói rõ ràng và tự tin để mọi người hiểu", "Không nói vì ngại", "Nói thật nhanh cho xong"], correct: 1 },
  { question: "Khi có thời gian rảnh sau giờ học, em nên làm gì để hợp lí nhất?", options: ["Chỉ chơi mà không cần học", "Sắp xếp thời gian học và chơi một cách phù hợp", "Ngủ suốt mà không làm gì", "Không cần lên kế hoạch"], correct: 1 },
  // T/F pair 7 (last TF)
  { question: "Việc gấp chăn màn gọn gàng mỗi sáng giúp phòng ngủ luôn sạch đẹp và rèn luyện tính kỷ luật", options: ["Đúng", "Sai"], correct: 0 },
  // 4-opt remaining
  { question: "Khi đứng trước lớp biểu diễn, em nên thể hiện như thế nào?", options: ["Trốn tránh vì sợ sai", "Tự tin và mạnh dạn thể hiện khả năng của mình", "Đứng im không biểu diễn", "Làm qua loa cho xong"], correct: 1 },
  { question: "Việc lập thời gian biểu giúp ích gì cho quá trình rèn luyện bản thân của em?", options: ["Để em có nhiều thời gian đi chơi hơn", "Giúp em sắp xếp công việc khoa học hơn", "Để khoe với bố mẹ và thầy cô", "Giúp em không cần phải làm việc nhà"], correct: 1 },
  { question: "Để nhận ra nét riêng của một người, em nên quan sát điều gì?", options: ["Màu sắc của chiếc cặp sách", "Điểm số của bạn trong bài kiểm tra", "Gương mặt, nụ cười, mái tóc hoặc màu da", "Nhãn hiệu đôi giày bạn đang đi"], correct: 2 },
];

const TEAM1_KEYS = ['a', 'w', 's', 'z'];
const TEAM2_KEYS = ['k', 'i', 'j', 'm'];
const KEY_LABELS_T1 = ['A', 'B', 'C', 'D'];
const KEY_LABELS_T2 = ['A', 'B', 'C', 'D'];
const ROUNDS = 5; // 5 lượt câu hỏi
const GAME_DURATION = 180; // 3 phút

function saveAchievement(data: object) {
  try {
    const key = 'bahnar_achievements';
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    existing.unshift({ ...data, date: new Date().toLocaleDateString('vi-VN') });
    localStorage.setItem(key, JSON.stringify(existing.slice(0, 50)));
  } catch (_) { /* ignore */ }
}

function useGameMusic(playing: boolean, muted: boolean) {
  const ctxRef = useRef<AudioContext | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    if (!playing || muted) {
      if (ctxRef.current) { ctxRef.current.close(); ctxRef.current = null; }
      if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
      return;
    }
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    ctxRef.current = ctx;
    const master = ctx.createGain();
    master.gain.value = 0.09;
    master.connect(ctx.destination);
    // Pentatonic C scale - Vietnamese folk / đồng dao feel
    const scale = [261.63, 293.66, 329.63, 392.00, 440.00, 523.25, 587.33];
    const melody = [2, 4, 3, 2, 1, 0, 2, 1, 3, 2, 4, 3, 5, 4, 3, 2, 1, 2, 3, 1, 0, 1, 2, 4, 3, 2, 0];
    const lens   = [1, 0.5, 0.5, 1, 0.5, 0.75, 0.25, 1, 0.5, 0.5, 1, 0.5, 0.5, 0.75, 0.25, 1, 0.5, 0.5, 0.5, 0.5, 0.75, 0.25, 0.5, 1, 0.5, 0.5, 1.5];
    const BEAT = 0.42;
    let idx = 0;
    let nextTime = ctx.currentTime + 0.05;
    const schedule = () => {
      if (!ctxRef.current) return;
      while (nextTime < ctx.currentTime + 0.4) {
        const dur = lens[idx % lens.length] * BEAT;
        const freq = scale[melody[idx % melody.length]];
        const m = ctx.createOscillator();
        const mg = ctx.createGain();
        m.connect(mg); mg.connect(master);
        m.type = 'triangle';
        m.frequency.value = freq;
        mg.gain.setValueAtTime(0, nextTime);
        mg.gain.linearRampToValueAtTime(0.65, nextTime + 0.015);
        mg.gain.setValueAtTime(0.55, nextTime + dur * 0.6);
        mg.gain.exponentialRampToValueAtTime(0.001, nextTime + dur * 0.9);
        m.start(nextTime); m.stop(nextTime + dur);
        if (idx % 2 === 0) {
          const h = ctx.createOscillator();
          const hg = ctx.createGain();
          h.connect(hg); hg.connect(master);
          h.type = 'sine';
          h.frequency.value = freq * 1.5;
          hg.gain.setValueAtTime(0, nextTime);
          hg.gain.linearRampToValueAtTime(0.15, nextTime + 0.015);
          hg.gain.exponentialRampToValueAtTime(0.001, nextTime + dur * 0.7);
          h.start(nextTime); h.stop(nextTime + dur);
        }
        if (idx % lens.length === 0 || idx % lens.length === Math.floor(lens.length / 2)) {
          const d = ctx.createOscillator();
          const dg = ctx.createGain();
          d.connect(dg); dg.connect(master);
          d.type = 'sine';
          d.frequency.setValueAtTime(100, nextTime);
          d.frequency.exponentialRampToValueAtTime(50, nextTime + 0.08);
          dg.gain.setValueAtTime(0.25, nextTime);
          dg.gain.exponentialRampToValueAtTime(0.001, nextTime + 0.1);
          d.start(nextTime); d.stop(nextTime + 0.12);
        }
        nextTime += lens[idx % lens.length] * BEAT;
        idx++;
      }
    };
    intervalRef.current = setInterval(schedule, 100);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (ctxRef.current) { ctxRef.current.close(); ctxRef.current = null; }
    };
  }, [playing, muted]);
}

function playAlarmBeep() {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    for (let i = 0; i < 3; i++) {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.connect(g); g.connect(ctx.destination);
      osc.type = 'square';
      osc.frequency.value = 880;
      const t = ctx.currentTime + i * 0.25;
      g.gain.setValueAtTime(0.3, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.18);
      osc.start(t); osc.stop(t + 0.2);
    }
    setTimeout(() => ctx.close(), 2000);
  } catch (_) { /* ignore */ }
}

function playStiltStepSound() {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    // Tiếng gỗ chạm đất: thud trầm + click gỗ
    const thud = ctx.createOscillator();
    const thudG = ctx.createGain();
    thud.connect(thudG); thudG.connect(ctx.destination);
    thud.type = 'sine';
    thud.frequency.setValueAtTime(180, ctx.currentTime);
    thud.frequency.exponentialRampToValueAtTime(60, ctx.currentTime + 0.12);
    thudG.gain.setValueAtTime(0.45, ctx.currentTime);
    thudG.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.18);
    thud.start(ctx.currentTime);
    thud.stop(ctx.currentTime + 0.2);
    // Click gỗ sắc
    const click = ctx.createOscillator();
    const clickG = ctx.createGain();
    click.connect(clickG); clickG.connect(ctx.destination);
    click.type = 'square';
    click.frequency.setValueAtTime(900, ctx.currentTime);
    click.frequency.exponentialRampToValueAtTime(300, ctx.currentTime + 0.04);
    clickG.gain.setValueAtTime(0.18, ctx.currentTime);
    clickG.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.06);
    click.start(ctx.currentTime);
    click.stop(ctx.currentTime + 0.07);
    // Tiếng vang nhỏ
    const echo = ctx.createOscillator();
    const echoG = ctx.createGain();
    echo.connect(echoG); echoG.connect(ctx.destination);
    echo.type = 'triangle';
    echo.frequency.setValueAtTime(120, ctx.currentTime + 0.05);
    echo.frequency.exponentialRampToValueAtTime(50, ctx.currentTime + 0.15);
    echoG.gain.setValueAtTime(0.12, ctx.currentTime + 0.05);
    echoG.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
    echo.start(ctx.currentTime + 0.05);
    echo.stop(ctx.currentTime + 0.22);
    setTimeout(() => ctx.close(), 500);
  } catch (_) { /* ignore */ }
}

function playCorrectSound() {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    const freqs = [523, 659, 784, 1047];
    freqs.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.connect(g); g.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * 0.08;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.28, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.22);
      osc.start(t); osc.stop(t + 0.25);
    });
    setTimeout(() => ctx.close(), 1200);
  } catch (_) { /* ignore */ }
}

function Fireworks() {
  const items = ['🎉', '🎊', '✨', '🌟', '⭐', '💫', '🎆', '🎇', '🥳', '🏆'];
  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {[...Array(30)].map((_, i) => (
        <div
          key={i}
          className="absolute"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${10 + Math.random() * 80}%`,
            fontSize: `${1 + Math.random() * 2}rem`,
            animation: `ping 0.8s ease-out ${i * 0.07}s both`,
          }}
        >
          {items[i % items.length]}
        </div>
      ))}
    </div>
  );
}

// ===== TÂY NGUYÊN STAIRCASE COMPONENT =====
function TayNguyenStaircase({
  steps,
  teamColor,
  charImg,
  charAlt,
  label,
  onStep,
}: {
  steps: number;
  teamColor: 'blue' | 'red';
  charImg: string;
  charAlt: string;
  label: string;
  onStep?: () => void;
}) {
  const STEP_H = 18;
  const totalH = ROUNDS * STEP_H + 80;
  const prevStepsRef = useRef(steps);
  const [jumping, setJumping] = useState(false);

  useEffect(() => {
    if (steps > prevStepsRef.current) {
      setJumping(true);
      if (onStep) onStep();
      const t = setTimeout(() => setJumping(false), 500);
      prevStepsRef.current = steps;
      return () => clearTimeout(t);
    }
    prevStepsRef.current = steps;
  }, [steps, onStep]);

  // Tây Nguyên wood + tribal color palette
  const teamAccent = teamColor === 'blue'
    ? { stripe: '#1d4ed8', diamond: '#bfdbfe', num: '#dbeafe', stilt: 'linear-gradient(to bottom, #1d4ed8, #93c5fd)', stiltBorder: '#1e40af' }
    : { stripe: '#b91c1c', diamond: '#fecaca', num: '#fee2e2', stilt: 'linear-gradient(to bottom, #b91c1c, #fca5a5)', stiltBorder: '#991b1b' };

  return (
    <div className="flex flex-col items-center mb-2">
      {/* Title label */}
      <div
        className="text-xs font-bold px-3 py-0.5 rounded-full mb-2 tracking-wider"
        style={{
          background: teamColor === 'blue' ? '#1d4ed8' : '#b91c1c',
          color: '#fef3c7',
          fontFamily: 'serif',
          letterSpacing: '0.08em',
        }}
      >
        ▲ {label} ▲
      </div>

      {/* Staircase container */}
      <div className="relative" style={{ width: 220, height: totalH }}>

        {/* Steps rendered bottom-up */}
        {[...Array(ROUNDS)].map((_, i) => {
          const stepIdx = ROUNDS - 1 - i;
          const stepW = 40 + stepIdx * 28;
          const stepBottom = i * STEP_H;
          const stepLeft = (220 - stepW) / 2;
          const woodBase = '#5c3d1e';
          const woodMid = '#78522a';
          const woodLight = '#a0714f';

          return (
            <div
              key={stepIdx}
              className="absolute"
              style={{ width: stepW, height: STEP_H, bottom: stepBottom, left: stepLeft }}
            >
              {/* Main step tread — wood grain base */}
              <div
                className="w-full"
                style={{
                  height: STEP_H - 3,
                  background: `linear-gradient(to bottom, ${woodLight} 0%, ${woodMid} 45%, ${woodBase} 100%)`,
                  borderRadius: '3px 3px 0 0',
                  border: '1.5px solid #3b2008',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.3)',
                }}
              >
                {/* Wood grain lines (horizontal streaks) */}
                <div className="absolute inset-0" style={{
                  backgroundImage: `repeating-linear-gradient(180deg,
                    transparent 0px, transparent 2px,
                    rgba(255,255,255,0.07) 2px, rgba(255,255,255,0.07) 3px,
                    transparent 3px, transparent 5px,
                    rgba(0,0,0,0.08) 5px, rgba(0,0,0,0.08) 6px
                  )`,
                }} />
                {/* Vertical wood grain subtle lines */}
                <div className="absolute inset-0" style={{
                  backgroundImage: `repeating-linear-gradient(90deg,
                    transparent 0px, transparent 8px,
                    rgba(0,0,0,0.05) 8px, rgba(0,0,0,0.05) 9px
                  )`,
                }} />
                {/* Bahnar thổ cẩm stripe accent */}
                <div className="absolute" style={{
                  top: 1, left: 0, right: 0, height: 2,
                  background: `repeating-linear-gradient(90deg,
                    ${teamAccent.stripe} 0px, ${teamAccent.stripe} 4px,
                    transparent 4px, transparent 8px,
                    ${teamAccent.diamond} 8px, ${teamAccent.diamond} 10px,
                    transparent 10px, transparent 14px
                  )`,
                  opacity: 0.25,
                }} />
                {/* Diamond motif center (thổ cẩm hình thoi) */}
                {stepW > 55 && (
                  <div className="absolute" style={{
                    top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%) rotate(45deg)',
                    width: 6, height: 6,
                    background: '#c4a882',
                    opacity: 0.4,
                  }} />
                )}

              </div>
              {/* Step riser (vertical face) — darker wood */}
              <div className="absolute" style={{
                bottom: 0, left: 0, right: 0, height: 3,
                background: '#3b2008',
                borderRadius: '0 0 2px 2px',
              }} />
            </div>
          );
        })}

        {/* Character standing on current step (starts at ground = 0) */}
        <div
          className="absolute flex flex-col items-center"
          style={{
            bottom: steps * STEP_H + 2,
            left: '50%',
            transform: `translateX(-50%) ${jumping ? 'translateY(-10px) scaleX(0.92)' : 'translateY(0px) scaleX(1)'}`,
            transition: jumping
              ? 'bottom 0.3s cubic-bezier(0.22,1.2,0.36,1), transform 0.15s ease-out'
              : 'bottom 0.45s cubic-bezier(0.34,1.56,0.64,1), transform 0.3s cubic-bezier(0.34,1.56,0.64,1)',
            zIndex: 10,
          }}
        >
          <img
            src={charImg}
            alt={charAlt}
            className="object-contain rounded-md"
            style={{
              height: 70, width: 'auto', maxWidth: 64,
              filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.4))',
              transform: jumping ? 'scaleY(0.88)' : 'scaleY(1)',
              transition: 'transform 0.15s ease-out',
            }}
          />
          <div style={{ display: 'flex', gap: 7, marginTop: 1 }}>
            <div style={{ width: 5, height: 20, background: teamAccent.stilt, borderRadius: 3, border: `1px solid ${teamAccent.stiltBorder}` }} />
            <div style={{ width: 5, height: 20, background: teamAccent.stilt, borderRadius: 3, border: `1px solid ${teamAccent.stiltBorder}` }} />
          </div>
        </div>
      </div>


    </div>
  );
}

// ===== RESULT STAIRCASE (full 5 steps, character at top) =====
function ResultStaircase({
  steps,
  teamColor,
  charImg,
  charAlt,
  isWinner,
}: {
  steps: number;
  teamColor: 'blue' | 'red';
  charImg: string;
  charAlt: string;
  isWinner: boolean;
}) {
  const STEP_H = 18;
  const totalH = ROUNDS * STEP_H + 80;

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: 180, height: totalH }}>

        {[...Array(ROUNDS)].map((_, i) => {
          const stepIdx = ROUNDS - 1 - i;
          const stepW = 30 + stepIdx * 24;
          const stepBottom = i * STEP_H;
          const stepLeft = (180 - stepW) / 2;
          const isActive = steps > stepIdx;

          // Color gradient from bottom (bright) to top (dark)
          // brightFactor: 1 at bottom, 0 at top → bottom steps are brightest
          const brightFactor = 1 - stepIdx / (ROUNDS - 1);
          const woodBase = isActive
            ? (teamColor === 'blue'
              ? `hsl(220, ${60 + brightFactor * 20}%, ${35 + brightFactor * 25}%)`
              : `hsl(0, ${60 + brightFactor * 20}%, ${35 + brightFactor * 25}%)`)
            : '#5c3d1e';
          const woodMid = isActive
            ? (teamColor === 'blue'
              ? `hsl(215, ${65 + brightFactor * 20}%, ${45 + brightFactor * 25}%)`
              : `hsl(0, ${65 + brightFactor * 20}%, ${45 + brightFactor * 25}%)`)
            : '#78522a';
          const woodLight = isActive
            ? (teamColor === 'blue'
              ? `hsl(210, ${70 + brightFactor * 20}%, ${60 + brightFactor * 20}%)`
              : `hsl(5, ${70 + brightFactor * 20}%, ${60 + brightFactor * 20}%)`)
            : '#a0714f';
          const diamondC = isActive ? (teamColor === 'blue' ? '#bfdbfe' : '#fecaca') : '#c4a882';
          const stripeC  = isActive ? (teamColor === 'blue' ? '#1d4ed8' : '#b91c1c') : '#6b4226';

          return (
            <div
              key={stepIdx}
              className="absolute"
              style={{ width: stepW, height: STEP_H, bottom: stepBottom, left: stepLeft }}
            >
              <div
                className="w-full"
                style={{
                  height: STEP_H - 3,
                  background: `linear-gradient(to bottom, ${woodLight} 0%, ${woodMid} 45%, ${woodBase} 100%)`,
                  borderRadius: '3px 3px 0 0',
                  border: `1.5px solid ${isActive ? (teamColor === 'blue' ? '#1e40af' : '#991b1b') : '#3b2008'}`,
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: isActive ? `0 2px 8px ${woodMid}66` : 'inset 0 1px 3px rgba(0,0,0,0.3)',
                }}
              >
                {/* Wood grain horizontal */}
                <div className="absolute inset-0" style={{
                  backgroundImage: `repeating-linear-gradient(180deg,
                    transparent 0px, transparent 2px,
                    rgba(255,255,255,0.07) 2px, rgba(255,255,255,0.07) 3px,
                    transparent 3px, transparent 5px,
                    rgba(0,0,0,0.08) 5px, rgba(0,0,0,0.08) 6px
                  )`,
                }} />
                {/* Bahnar stripe accent */}
                <div className="absolute" style={{
                  top: 1, left: 0, right: 0, height: 2,
                  background: `repeating-linear-gradient(90deg,
                    ${stripeC} 0px, ${stripeC} 4px,
                    transparent 4px, transparent 8px,
                    ${diamondC} 8px, ${diamondC} 10px,
                    transparent 10px, transparent 14px
                  )`,
                  opacity: isActive ? 0.75 : 0.25,
                }} />
                {/* Diamond motif */}
                {stepW > 45 && (
                  <div className="absolute" style={{
                    top: '50%', left: '50%',
                    transform: 'translate(-50%,-50%) rotate(45deg)',
                    width: 5, height: 5,
                    background: diamondC,
                    opacity: isActive ? 0.85 : 0.4,
                  }} />
                )}
              </div>
              <div className="absolute" style={{
                bottom: 0, left: 0, right: 0, height: 3,
                background: isActive ? (teamColor === 'blue' ? '#1e3a5f' : '#7f1d1d') : '#3b2008',
                borderRadius: '0 0 2px 2px',
              }} />
            </div>
          );
        })}

        {/* Character at their step position (starts at ground) */}
        <div
          className="absolute flex flex-col items-center"
          style={{
            bottom: steps * STEP_H + 2,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10,
          }}
        >
          {isWinner && <div style={{ fontSize: 16, marginBottom: 2 }}>🏆</div>}
          <img
            src={charImg}
            alt={charAlt}
            className="object-contain rounded-md"
            style={{
              height: 52,
              width: 'auto',
              maxWidth: 48,
              filter: `drop-shadow(0 2px 8px rgba(0,0,0,0.4)) ${isWinner ? 'brightness(1.1)' : ''}`,
            }}
          />
          <div style={{ display: 'flex', gap: 6, marginTop: 1 }}>
            <div style={{ width: 5, height: 22, background: teamColor === 'blue' ? 'linear-gradient(to bottom, #1d4ed8, #93c5fd)' : 'linear-gradient(to bottom, #b91c1c, #fca5a5)', borderRadius: 3, border: `1px solid ${teamColor === 'blue' ? '#1e40af' : '#991b1b'}` }} />
            <div style={{ width: 5, height: 22, background: teamColor === 'blue' ? 'linear-gradient(to bottom, #1d4ed8, #93c5fd)' : 'linear-gradient(to bottom, #b91c1c, #fca5a5)', borderRadius: 3, border: `1px solid ${teamColor === 'blue' ? '#1e40af' : '#991b1b'}` }} />
          </div>
        </div>
      </div>

    </div>
  );
}

export default function CaKheoGame({ onBack }: { onBack: () => void }) {
  const [phase, setPhase] = useState<'quiz' | 'race' | 'result'>('quiz');
  const [t1QIdx, setT1QIdx] = useState(0);
  const [t2QIdx, setT2QIdx] = useState(1);
  const [t1Selected, setT1Selected] = useState<number | null>(null);
  const [t2Selected, setT2Selected] = useState<number | null>(null);
  const [t1ShowResult, setT1ShowResult] = useState(false);
  const [t2ShowResult, setT2ShowResult] = useState(false);
  const [t1Locked, setT1Locked] = useState(false);
  const [t2Locked, setT2Locked] = useState(false);
  const [timeLeft, setTimeLeft] = useState(GAME_DURATION);
  const [team1Score, setTeam1Score] = useState(0);
  const [team2Score, setTeam2Score] = useState(0);
  const [team1Stilts, setTeam1Stilts] = useState(3);
  const [team2Stilts, setTeam2Stilts] = useState(3);
  const [team1Steps, setTeam1Steps] = useState(0);
  const [team2Steps, setTeam2Steps] = useState(0);
  const [t1RoundCount, setT1RoundCount] = useState(0);
  const [t2RoundCount, setT2RoundCount] = useState(0);
  const [raceProgress1, setRaceProgress1] = useState(0);
  const [raceProgress2, setRaceProgress2] = useState(0);
  const [winner, setWinner] = useState<1 | 2 | 'draw' | null>(null);
  const [saved, setSaved] = useState(false);
  const [showFireworks, setShowFireworks] = useState(false);
  const [pressedKey, setPressedKey] = useState<string | null>(null);
  const [muted, setMuted] = useState(false);
  const alarmPlayedRef = useRef(false);

  const q1 = QUESTIONS[t1QIdx % QUESTIONS.length];
  const q2 = QUESTIONS[t2QIdx % QUESTIONS.length];

  useGameMusic(phase === 'quiz', muted);

  const isUrgent = timeLeft <= 5;
  const quizDone = t1RoundCount >= ROUNDS && t2RoundCount >= ROUNDS;

  const handleRestart = () => {
    setPhase('quiz');
    setT1QIdx(0);
    setT2QIdx(1);
    setT1Selected(null);
    setT2Selected(null);
    setT1ShowResult(false);
    setT2ShowResult(false);
    setT1Locked(false);
    setT2Locked(false);
    setTimeLeft(GAME_DURATION);
    setTeam1Score(0);
    setTeam2Score(0);
    setTeam1Stilts(3);
    setTeam2Stilts(3);
    setTeam1Steps(0);
    setTeam2Steps(0);
    setT1RoundCount(0);
    setT2RoundCount(0);
    setRaceProgress1(0);
    setRaceProgress2(0);
    setWinner(null);
    setSaved(false);
    setShowFireworks(false);
    setPressedKey(null);
    alarmPlayedRef.current = false;
  };

  // Timer
  useEffect(() => {
    if (phase !== 'quiz') return;
    if (timeLeft <= 0 || quizDone) {
      setPhase('race');
      return;
    }
    if (timeLeft === 5 && !alarmPlayedRef.current) {
      alarmPlayedRef.current = true;
      if (!muted) playAlarmBeep();
    }
    const t = setTimeout(() => setTimeLeft(p => p - 1), 1000);
    return () => clearTimeout(t);
  }, [timeLeft, phase, quizDone, muted]);

  // Keyboard
  useEffect(() => {
    if (phase !== 'quiz') return;
    const handleKey = (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();
      setPressedKey(key);
      setTimeout(() => setPressedKey(null), 200);

      if (TEAM1_KEYS.includes(key) && !t1Locked && t1RoundCount < ROUNDS) {
        const idx = TEAM1_KEYS.indexOf(key);
        if (idx >= q1.options.length) return;
        setT1Selected(idx);
        setT1Locked(true);
        const correct = idx === q1.correct;
        if (correct) {
          setTeam1Score(p => p + 10);
          setTeam1Steps(p => Math.min(p + 1, ROUNDS));
          if (!muted) playCorrectSound();
        } else {
          setTeam1Stilts(p => p + 1);
        }
        setT1ShowResult(true);
        setT1RoundCount(p => p + 1);
        setTimeout(() => {
          setT1ShowResult(false);
          setT1Selected(null);
          setT1Locked(false);
          setT1QIdx(p => p + 2);
        }, 1200);
      } else if (TEAM2_KEYS.includes(key) && !t2Locked && t2RoundCount < ROUNDS) {
        const idx = TEAM2_KEYS.indexOf(key);
        if (idx >= q2.options.length) return;
        setT2Selected(idx);
        setT2Locked(true);
        const correct = idx === q2.correct;
        if (correct) {
          setTeam2Score(p => p + 10);
          setTeam2Steps(p => Math.min(p + 1, ROUNDS));
          if (!muted) playCorrectSound();
        } else {
          setTeam2Stilts(p => p + 1);
        }
        setT2ShowResult(true);
        setT2RoundCount(p => p + 1);
        setTimeout(() => {
          setT2ShowResult(false);
          setT2Selected(null);
          setT2Locked(false);
          setT2QIdx(p => p + 2);
        }, 1200);
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [phase, t1Locked, t2Locked, q1.correct, q2.correct, t1RoundCount, t2RoundCount, q1.options.length, q2.options.length, muted]);

  // Race animation — speed based on steps climbed
  useEffect(() => {
    if (phase !== 'race') return;
    const speed1 = Math.max(team1Steps, 1);
    const speed2 = Math.max(team2Steps, 1);
    const interval = setInterval(() => {
      setRaceProgress1(p => Math.min(p + speed1 * 1.8, 100));
      setRaceProgress2(p => Math.min(p + speed2 * 1.8, 100));
    }, 80);
    const done = setTimeout(() => {
      clearInterval(interval);
      setRaceProgress1(100);
      setRaceProgress2(100);
      const w: 1 | 2 | 'draw' = team1Steps > team2Steps ? 1 : team2Steps > team1Steps ? 2 : team1Score > team2Score ? 1 : team2Score > team1Score ? 2 : 'draw';
      setWinner(w);
      setShowFireworks(true);
      setTimeout(() => { setShowFireworks(false); setPhase('result'); }, 4000);
    }, Math.max(ROUNDS - Math.min(team1Steps, team2Steps) + 1, 2) * 700);
    return () => { clearInterval(interval); clearTimeout(done); };
  }, [phase, team1Steps, team2Steps, team1Score, team2Score]);

  const handleSave = () => {
    saveAchievement({ game: 'Thi cà kheo lên dốc', winner: winner === 'draw' ? 'Hòa' : `Đội ${winner === 1 ? 'Xanh' : 'Đỏ'}`, team1Score, team2Score });
    setSaved(true);
  };

  const mins = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;

  if (phase === 'race') {
    const teams = [
      {
        team: 1, stilts: team1Stilts, score: team1Score, progress: raceProgress1,
        color: 'sky', emoji: '🔵', label: 'Xanh',
        img: 'https://storage.readdy-site.link/project_files/d941aef1-6212-4727-9a5e-0c38b2f72f78/94900438-278b-4512-a4c8-a0051662f551_z7654735097985_1fbdf4b5978515b69524e55508dd1afa.jpg?v=9b726042923dbc03ba013f4a9a07cb3b',
      },
      {
        team: 2, stilts: team2Stilts, score: team2Score, progress: raceProgress2,
        color: 'red', emoji: '🔴', label: 'Đỏ',
        img: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/3b65d892bebb36f8aa088924a567b664.jpeg',
      },
    ];
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6 py-8"
        style={{ background: 'linear-gradient(180deg, #7eccea 0%, #b3dfa0 40%, #5aaa5a 70%, #3d7a3d 100%)' }}>
        {showFireworks && <Fireworks />}
        <h2 className="text-3xl font-extrabold text-white mb-1 drop-shadow-lg">🏁 Thi đi cà kheo lên dốc!</h2>
        <p className="text-white/90 mb-6 text-sm drop-shadow font-semibold">Cà kheo ngắn = đi nhanh | Trả lời sai = thêm 1 đoạn cà kheo!</p>

        <div className="w-full max-w-3xl space-y-5">
          {teams.map(({ team, stilts, score, progress, color, emoji, label, img }) => (
            <div key={team}>
              <div className="flex items-center gap-3 mb-2 px-1">
                <span className="text-xl">{emoji}</span>
                <span className="font-extrabold text-white drop-shadow">Đội {label}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full font-bold ${color === 'sky' ? 'bg-sky-200 text-sky-800' : 'bg-red-200 text-red-800'}`}>
                  🪜 {team === 1 ? team1Steps : team2Steps}/{ROUNDS} bậc
                </span>
                <span className="text-xs font-extrabold text-white ml-auto drop-shadow">{score} điểm</span>
              </div>

              {/* Race track */}
              <div className="relative rounded-2xl overflow-hidden border-2 border-white/30" style={{ height: 160 }}>
                {/* Sky */}
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, #c8e6f5 0%, #e8f5e9 60%, #a5d6a7 100%)' }} />
                {/* Slope */}
                <div className="absolute bottom-0 left-0 right-0" style={{ height: 36, background: 'linear-gradient(to top, #6d4c41 0%, #8d6e63 100%)' }} />
                <div className="absolute bottom-8 left-0 right-0 h-5" style={{ background: 'linear-gradient(to top, #4caf50 0%, #66bb6a 100%)' }} />
                <div className="absolute top-4 bottom-9 left-0 right-0 flex items-end px-4">
                  <div className="w-full border-t-2 border-dashed border-white/30" />
                </div>
                {/* Start flag */}
                <div className="absolute left-3 top-2 flex flex-col items-center" style={{ zIndex: 2 }}>
                  <span className="text-base">🏳️</span>
                  <div className="w-0.5 h-6 bg-white/50" />
                </div>
                {/* Finish flag */}
                <div className="absolute right-3 top-0 flex flex-col items-center" style={{ zIndex: 2 }}>
                  <span className="text-2xl">🏁</span>
                  <div className="w-0.5 h-16 bg-white/60" />
                </div>

                {/* Moving character */}
                <div
                  className="absolute flex flex-col items-center"
                  style={{
                    left: `${Math.max(6, Math.min(82, progress))}%`,
                    bottom: 10,
                    transform: 'translateX(-50%)',
                    transition: 'left 0.3s ease-out',
                    zIndex: 3,
                  }}
                >
                  {/* Stilt column */}
                  <div
                    className="rounded-sm mb-0.5"
                    style={{
                      width: 10,
                      height: stilts * 12,
                      background: stilts <= 3
                        ? (color === 'sky' ? 'linear-gradient(to bottom, #0ea5e9, #7dd3fc)' : 'linear-gradient(to bottom, #ef4444, #fca5a5)')
                        : `linear-gradient(to bottom, #f97316 0%, #fb923c ${((stilts - 3) / stilts) * 100}%, ${color === 'sky' ? '#0ea5e9' : '#ef4444'} ${((stilts - 3) / stilts) * 100}%, ${color === 'sky' ? '#7dd3fc' : '#fca5a5'} 100%)`,
                      border: '1px solid rgba(255,255,255,0.5)',
                      transition: 'height 0.4s ease',
                    }}
                  />
                  <img
                    src={img}
                    alt={`Đội ${label}`}
                    className="object-contain object-bottom rounded-lg"
                    style={{
                      height: 72 + stilts * 4,
                      width: 'auto',
                      maxWidth: 72,
                      filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.5)) contrast(1.15) brightness(1.05)',
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-white animate-pulse font-semibold text-base drop-shadow">Đang thi đua lên dốc... 🏔️</p>
      </div>
    );
  }

  if (phase === 'result') {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 relative overflow-hidden">
        {/* Blurred background */}
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Festive%20Bahnar%20highland%20celebration%20village%20Vietnam%20colorful%20traditional%20flags%20bamboo%20decorations%20stilt%20houses%20rice%20fields%20green%20mountains%20joyful%20atmosphere%20warm%20golden%20light%20watercolor%20illustration&width=1280&height=800&seq=cakheo-result-bg-v2&orientation=landscape)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className="absolute inset-0 z-0 bg-white/65 backdrop-blur-md" />

        {showFireworks && <Fireworks />}
        <div className="relative z-10 flex flex-col items-center">
          <div className="text-8xl mb-4 animate-bounce">{winner === 'draw' ? '🤝' : '🏆'}</div>
          <h2 className="text-4xl font-extrabold text-primary-brown-dark mb-2">
            {winner === 'draw' ? 'Hòa nhau!' : `Đội ${winner === 1 ? '🔵 Xanh' : '🔴 Đỏ'} thắng!`}
          </h2>
          <p className="text-primary-brown-light mb-8 text-center max-w-md text-lg">
            {winner === 'draw' ? 'Hai đội về đích cùng lúc !' : `Đội ${winner === 1 ? 'Xanh' : 'Đỏ'} đi cà kheo vượt dốc nhanh hơn!`}
          </p>
          <div className="flex gap-6 mb-8">
            <div className="bg-sky-50/90 rounded-3xl px-10 py-6 text-center border-2 border-sky-300 backdrop-blur-sm">
              <div className="text-4xl mb-2">🔵</div>
              <p className="font-extrabold text-sky-700 text-3xl">{team1Score} điểm</p>

            </div>
            <div className="bg-red-50/90 rounded-3xl px-10 py-6 text-center border-2 border-red-300 backdrop-blur-sm">
              <div className="text-4xl mb-2">🔴</div>
              <p className="font-extrabold text-red-600 text-3xl">{team2Score} điểm</p>

            </div>
          </div>

          <div className="flex gap-4 flex-wrap justify-center">
            {!saved ? (
              <button onClick={handleSave} className="px-7 py-3 bg-gradient-to-r from-green-500 to-emerald-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
                <i className="ri-trophy-fill"></i> Lưu thành tích
              </button>
            ) : (
              <div className="px-7 py-3 bg-green-100 text-green-700 font-bold rounded-2xl flex items-center gap-2">
                <i className="ri-check-fill"></i> Đã lưu!
              </div>
            )}
            <button onClick={handleRestart} className="px-7 py-3 bg-gradient-to-r from-sky-500 to-sky-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-restart-line"></i> Chơi lại
            </button>
            <button onClick={onBack} className="px-7 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-home-4-line"></i> Trở về Trang chủ
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col relative" style={{ minWidth: 768 }}>
      {/* Background image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Beautiful%20Bahnar%20highland%20village%20Vietnam%20mountain%20landscape%20bamboo%20forest%20green%20hills%20traditional%20wooden%20stilt%20houses%20colorful%20festive%20banners%20soft%20morning%20light%20watercolor%20illustration%20style%20muted%20warm%20tones%20peaceful%20scenery&width=1280&height=800&seq=cakheo-quiz-bg-v2&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Frosted overlay */}
      <div className="absolute inset-0 z-0 bg-white/60 backdrop-blur-sm" />

      {/* Content layer */}
      <div className="relative z-10 flex flex-col flex-1">
        {/* Red alarm overlay when urgent */}
        {isUrgent && (
          <div
            className="fixed inset-0 pointer-events-none z-30 animate-pulse"
            style={{ boxShadow: 'inset 0 0 80px rgba(220,38,38,0.65)', border: '6px solid rgba(220,38,38,0.75)' }}
          />
        )}

        {/* Decorative header */}
        <div className="w-full py-1 text-center text-xs font-bold tracking-widest text-white relative"
          style={{ background: 'linear-gradient(90deg, #0ea5e9, #22c55e, #f97316)' }}>
          🔵 ĐỘI XANH &nbsp;🎋&nbsp; THI ĐI CÀ KHEO LÊN DỐC &nbsp;🎋&nbsp; ĐỘI ĐỎ 🔴
          {/* Mute button */}
          <button
            onClick={() => setMuted(m => !m)}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center bg-white/20 hover:bg-white/40 rounded-full transition-colors cursor-pointer"
            title={muted ? 'Bật tiếng' : 'Tắt tiếng'}
          >
            <i className={`${muted ? 'ri-volume-mute-fill' : 'ri-volume-up-fill'} text-white text-sm`}></i>
          </button>
        </div>

        {/* Timer + Score */}
        <div className={`px-6 py-3 flex items-center justify-between border-b-2 transition-colors ${isUrgent ? 'bg-red-50/90 border-red-400' : 'bg-white/70 border-white/40'}`}>
          <div className="flex items-center gap-3 bg-sky-50/90 rounded-2xl px-5 py-2 border-2 border-sky-300">
            <span className="text-2xl">🔵</span>
            <div>
              <p className="text-xs text-sky-500 font-bold">Đội Xanh</p>
              <p className="text-xl font-extrabold text-sky-700">{team1Score} điểm</p>
            </div>
          </div>

          <div className="text-center flex flex-col items-center">
            <div className={`text-4xl font-extrabold font-mono transition-all ${isUrgent ? 'text-red-600 animate-pulse scale-125' : 'text-primary-brown-dark'}`}>
              {mins}:{secs.toString().padStart(2, '0')}
            </div>
            {isUrgent && (
              <p className="text-xs text-red-600 font-bold animate-bounce bg-red-100 px-2 py-0.5 rounded-full">
                🚨 SẮP KẾT THÚC!
              </p>
            )}
            {!isUrgent && <p className="text-xs text-primary-brown-light">⏱ Còn lại</p>}
          </div>

          <div className="flex items-center gap-3 bg-red-50/90 rounded-2xl px-5 py-2 border-2 border-red-300">
            <div className="text-right">
              <p className="text-xs text-red-400 font-bold">Đội Đỏ&nbsp;</p>
              <p className="text-xl font-extrabold text-red-600">{team2Score} điểm</p>
            </div>
            <span className="text-2xl">🔴</span>
          </div>
        </div>

        {/* Split screen */}
        <div className="flex flex-1">
          {/* Team 1 */}
          <div className="flex-1 flex flex-col px-5 pt-4 pb-3"
            style={{ background: 'linear-gradient(180deg, rgba(224,242,254,0.75) 0%, rgba(255,255,255,0.4) 100%)' }}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-lg font-extrabold text-sky-700 flex items-center gap-2">
                <span className="text-2xl">🔵</span> Đội Xanh
              </h3>
              {t1ShowResult && (
                <span className={`text-xs font-bold px-2 py-1 rounded-full animate-pulse ${t1Selected === q1.correct ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                  {t1Selected === q1.correct ? '✅ Đúng! +10đ' : '❌ Sai! Cà kheo dài thêm!'}
                </span>
              )}
              {t1RoundCount >= ROUNDS && (
                <span className="text-xs font-bold px-2 py-1 rounded-full bg-amber-100 text-amber-600">⏳ Chờ Đội Đỏ...</span>
              )}
            </div>

            {/* Team 1 staircase indicator */}
            <TayNguyenStaircase
              steps={team1Steps}
              teamColor="blue"
              charImg="https://storage.readdy-site.link/project_files/d941aef1-6212-4727-9a5e-0c38b2f72f78/94900438-278b-4512-a4c8-a0051662f551_z7654735097985_1fbdf4b5978515b69524e55508dd1afa.jpg?v=9b726042923dbc03ba013f4a9a07cb3b"
              charAlt="Học sinh đội xanh"
              label="ĐỘI XANH"
              onStep={() => { if (!muted) playStiltStepSound(); }}
            />

            {t1RoundCount < ROUNDS ? (
              <div className="bg-white/85 rounded-2xl p-4 flex-1 border border-sky-100">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs bg-sky-100 text-sky-600 font-bold px-2 py-0.5 rounded-full">Vòng {t1RoundCount + 1}/{ROUNDS}</span>
                </div>
                <p className="text-lg font-bold text-primary-brown-dark mb-3 leading-relaxed">{q1.question}</p>
                <div className="space-y-2">
                  {q1.options.map((opt, idx) => {
                    let cls = 'border-2 border-sky-200 bg-sky-50/50 text-primary-brown hover:border-sky-400';
                    if (t1ShowResult) {
                      if (idx === q1.correct) cls = 'border-2 border-green-400 bg-green-50 text-green-700 font-bold';
                      else if (idx === t1Selected && idx !== q1.correct) cls = 'border-2 border-red-400 bg-red-50 text-red-600';
                      else cls = 'border-2 border-sky-100 bg-white/40 text-primary-brown-light';
                    } else if (t1Selected === idx) cls = 'border-2 border-sky-500 bg-sky-100 text-sky-700 font-bold';
                    const kp = pressedKey === TEAM1_KEYS[idx];
                    return (
                      <div key={idx} className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm transition-all ${cls} ${kp ? 'scale-95' : ''}`}>
                        <span className={`w-7 h-7 flex items-center justify-center rounded-lg font-extrabold text-xs flex-shrink-0 ${kp ? 'bg-sky-500 text-white' : 'bg-sky-200 text-sky-700'}`}>
                          {KEY_LABELS_T1[idx]}
                        </span>
                        <span className="leading-tight">{opt}</span>
                        {t1ShowResult && idx === q1.correct && <i className="ri-check-line text-green-500 ml-auto"></i>}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="bg-sky-50/90 rounded-2xl p-6 flex-1 flex flex-col items-center justify-center border-2 border-sky-200">
                <div className="text-5xl mb-3">🎋</div>
                <p className="font-bold text-sky-700 text-center">Đội Xanh đã hoàn thành {ROUNDS} vòng!</p>
                <p className="text-sm text-sky-500 text-center mt-1">Đang chờ Đội Đỏ...</p>
              </div>
            )}
          </div>

          {/* Divider */}
          <div className="w-1 bg-gradient-to-b from-sky-300 via-green-300 to-amber-300 flex-shrink-0"></div>

          {/* Team 2 */}
          <div className="flex-1 flex flex-col px-5 pt-4 pb-3"
            style={{ background: 'linear-gradient(180deg, rgba(254,226,226,0.75) 0%, rgba(255,255,255,0.4) 100%)' }}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-lg font-extrabold text-red-600 flex items-center gap-2">
                <span className="text-2xl">🔴</span> Đội Đỏ
              </h3>
              {t2ShowResult && (
                <span className={`text-xs font-bold px-2 py-1 rounded-full animate-pulse ${t2Selected === q2.correct ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                  {t2Selected === q2.correct ? '✅ Đúng! +10đ' : '❌ Sai! Cà kheo dài thêm!'}
                </span>
              )}
              {t2RoundCount >= ROUNDS && (
                <span className="text-xs font-bold px-2 py-1 rounded-full bg-amber-100 text-amber-600">⏳ Chờ Đội Xanh...</span>
              )}
            </div>

            {/* Team 2 staircase indicator */}
            <TayNguyenStaircase
              steps={team2Steps}
              teamColor="red"
              charImg="https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/3b65d892bebb36f8aa088924a567b664.jpeg"
              charAlt="Học sinh đội đỏ"
              label="ĐỘI ĐỎ"
              onStep={() => { if (!muted) playStiltStepSound(); }}
            />

            {t2RoundCount < ROUNDS ? (
              <div className="bg-white/85 rounded-2xl p-4 flex-1 border border-red-100">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs bg-red-100 text-red-500 font-bold px-2 py-0.5 rounded-full">Vòng {t2RoundCount + 1}/{ROUNDS}</span>
                </div>
                <p className="text-lg font-bold text-primary-brown-dark mb-3 leading-relaxed">{q2.question}</p>
                <div className="space-y-2">
                  {q2.options.map((opt, idx) => {
                    let cls = 'border-2 border-red-200 bg-red-50/50 text-primary-brown hover:border-red-400';
                    if (t2ShowResult) {
                      if (idx === q2.correct) cls = 'border-2 border-green-400 bg-green-50 text-green-700 font-bold';
                      else if (idx === t2Selected && idx !== q2.correct) cls = 'border-2 border-red-400 bg-red-50 text-red-600';
                      else cls = 'border-2 border-red-100 bg-white/40 text-primary-brown-light';
                    } else if (t2Selected === idx) cls = 'border-2 border-red-500 bg-red-100 text-red-700 font-bold';
                    const kp = pressedKey === TEAM2_KEYS[idx];
                    return (
                      <div key={idx} className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm transition-all ${cls} ${kp ? 'scale-95' : ''}`}>
                        <span className={`w-7 h-7 flex items-center justify-center rounded-lg font-extrabold text-xs flex-shrink-0 ${kp ? 'bg-red-500 text-white' : 'bg-red-200 text-red-700'}`}>
                          {KEY_LABELS_T2[idx]}
                        </span>
                        <span className="leading-tight">{opt}</span>
                        {t2ShowResult && idx === q2.correct && <i className="ri-check-line text-green-500 ml-auto"></i>}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="bg-red-50/90 rounded-2xl p-6 flex-1 flex flex-col items-center justify-center border-2 border-red-200">
                <div className="text-5xl mb-3">🎋</div>
                <p className="font-bold text-red-600 text-center">Đội Đỏ đã hoàn thành {ROUNDS} vòng!</p>
                <p className="text-sm text-red-400 text-center mt-1">Đang chờ Đội Xanh...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
